const styles = (theme) => {
  return {
    root: {
      textAlign: 'center',
      position: 'absolute',
      width: '100%',
      zIndex: '1',
      top: '35%'
    },
    NeedHelp: {
      color: '#aaa',
      display: 'grid',
      padding: '10px',
      fontSize: '0.90rem',
      float: 'left',
      width: '33.3333%',
      textAlign: 'left'
    },
    logo: {
      color: '#aaa',
      display: 'flex',
      padding: '10px',
      fontSize: '0.90rem',
      float: 'left',
      //width: '100%',
      width: '33.3333%',
      justifyContent: 'center'
    },
    exit: {
      color: '#aaa',
      display: 'grid',
      padding: '10px',
      fontSize: '0.90rem',
      float: 'left',
      width: '33.3333%',
      textAlign: 'right'
    },
    labelClass: {
      padding: '0px 35px'
    },
    spanLink: {
      cursor: 'pointer'
    },
    ExitlabelClass: {
      padding: '0px 35px 0px 0px'
    },
    dialogBackground: {
      //background: 'linear-gradient(155deg, #ce907b 0%,#ffcfa6 90%)'
      background: 'transperent'
    },
    dialogContentColor: {
      //color: '#387371',
      color: '#77818D',
      textAlign: 'center',
      fontSize: '1.9em',
      fontWeight: '500'
    },
    alignButton: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    buttonColor: {
      //color: '#387371',
      color: 'black',
      fontSize: '1.9em'
    },
    imgProperty: {
      // opacity: '0.5'
    },
    primaryButton: {
      marginTop: '1em',
      //background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
      background: ' #2F5597',
      borderRadius: '10px',
      color: '#fff',
      fontSize: '20px',
      width: '30%',
      '&:hover': {
        background: ' #2F5597'
      }
    },
    '@media only screen and (min-width: 1440px) and (orientation:landscape)': {
      logo: {
        color: '#aaa',
        display: 'grid',
        padding: '10px',
        fontSize: '0.90rem',
        float: 'left',
        width: '33.3333%',
        justifyContent: 'center'
      },
      imgProperty: {
        height: '70px'
      }
    }
  };
};

export default styles;
